import Alpine from 'alpinejs';

function syncSteppedScrollVisibility(activeMode) {
    const toggle = document.querySelector('[data-component="toggle"]');
    if (!toggle || !activeMode) {
        return;
    }

    document.querySelectorAll('[data-component="stepped-scroll"]').forEach((section) => {
        const selection = section.getAttribute('data-toggle-selection');
        if (!selection) {
            return;
        }

        const visible = selection === activeMode;
        section.hidden = !visible;
        section.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
}

Alpine.data('toggleBlock', (initialConfig = {}) => ({
    slot: 0,
    modes: [],
    labels: {},

    init() {
        this.slot = initialConfig.slot ?? 0;
        this.modes = initialConfig.modes ?? [];
        this.labels = initialConfig.labels ?? {};

        this.$watch('slot', () => {
            this.syncSteppedScrolls();
        });

        this.syncSteppedScrolls();
    },

    syncSteppedScrolls() {
        const activeMode = this.modes[this.slot];
        if (activeMode) {
            this.$el.setAttribute('data-toggle-active-mode', activeMode);
        }
        syncSteppedScrollVisibility(activeMode);
    },
}));

document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-component="toggle"]');
    if (!toggle) {
        return;
    }

    const activeMode = toggle.getAttribute('data-toggle-active-mode');
    if (activeMode) {
        syncSteppedScrollVisibility(activeMode);
    }
});
